import { Component } from '@angular/core';
import { AssetUrlPipe } from '../pipes/asset-url.pipe';

@Component({
    selector: 'app-no-required-date',
    templateUrl: './no-required-date.component.html',
    styleUrl: './no-required-date.component.scss',
    imports: [AssetUrlPipe]
})
export class NoRequiredDateComponent {

}
